import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ChatbotWidget from "@/components/feature/ChatbotWidget";
import Hero from "@/pages/home/components/Hero";
import TrustIndicators from "@/pages/home/components/TrustIndicators";
import WhoWeHelp from "@/pages/home/components/WhoWeHelp";
import YouMightBeFeeling from "@/pages/home/components/YouMightBeFeeling";
import WhyChoose from "@/pages/home/components/WhyChoose";
import Therapists from "@/pages/home/components/Therapists";
import HowItWorks from "@/pages/home/components/HowItWorks";
import Pricing from "@/pages/home/components/Pricing";
import FAQ from "@/pages/home/components/FAQ";

export default function Home() {
  return (
    <>
      <main className="bg-[#FBF9F6] font-manrope">
      <Navbar />
      <Hero />
      <YouMightBeFeeling />
      <WhoWeHelp />
      <TrustIndicators />
      <WhyChoose />
      <Therapists />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <Footer />
      <ChatbotWidget />
      </main>
    </>
  );
}
